module.exports = __webpack_public_path__ + "img/gzh_top_nav.82ba9f16.jpg";